import { useMutation, useQueryClient } from "react-query";
import Axios from "../../setting/axios";
import dayjs from "dayjs";

const DateTime = dayjs().format("YYYY-MM-DD HH:mm:ss");

// Get current user's profile details
export const GetUserDetails = async () => {
  try {
    const response = await Axios.post(`/profile/get-profile-details`);
    return response;
  } catch (err) {
    console.error("Error fetching user details:", err);
    throw err;
  }
};

// Get all user profiles (for admin)
export const GetAllUserProfileDetails = async () => {
  try {
    const response = await Axios.post(`/profile/get-all-profile-details`);
    return response;
  } catch (err) {
    console.error("Error fetching all profiles:", err);
    throw err;
  }
};

// Get profile by specific user ID
export const GetProfileById = async (u_id) => {
  try {
    const response = await Axios.post(`/profile/profile-by-id`, { u_id });
    return response;
  } catch (err) {
    console.error("Error fetching profile by ID:", err);
    throw err;
  }
};

// Update profile details - handles both form data and image
const UpdateProfileDetails = async (data) => {
  try {
    // data comes as { values, image, isImageSelected, previousProfileImage }
    const response = await Axios.post(`/profile/update-profile-details`, {
      data: data,
      DateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"), // Fresh timestamp
    });
    return response;
  } catch (err) {
    console.error("Error updating profile:", err);
    throw err;
  }
};

// Custom hook for updating profile with automatic cache invalidation
export const useUpdateProfileDetails = () => {
  const queryClient = useQueryClient();

  return useMutation(UpdateProfileDetails, {
    onSuccess: () => {
      // Invalidate the UserDetails query to trigger a refetch
      queryClient.invalidateQueries("UserDetails");
    },
  });
};

// Hook for getting profile by ID
export const useProfileById = () => {
  return useMutation(GetProfileById);
};

// Hook for getting all profiles
export const useGetAllProfiles = () => {
  return useMutation(GetAllUserProfileDetails);
};